<template>
  <el-image :src="`${isNeedFix ? portiaBaseUrl : ''}${avatar}?imageView2/3/w/120/h/120/q/100` || require('@/assets/images/portia.png')" class="v-portia" :class="customeClass" v-if="avatar">
    <div slot="error">
      <img :src="require('@/assets/images/default-admin.png')" class="v-portia" :class="customeClass" />
    </div>
    <div slot="placeholder">
      <img :src="require('@/assets/images/defaulrPor.png')" class="v-portia" :class="customeClass" />
    </div>
  </el-image>
  <img v-else :src="require('@/assets/images/default-admin.png')" class="v-portia" :class="customeClass"/>
</template>
<script>
import defaultSetting from '@/setting/index';
export default{
  name: 'DefaultPortia',
  props: {
    avatar: String,
    customeClass: String,
    isNeedFix: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      portiaBaseUrl: defaultSetting.sourceUrl
    }
  }
}
</script>
<style scoped>
.v-portia{
  display: inline-block;
  object-fit: cover;
  border-radius: 50%;
}
</style>